import { include } from 'named-urls';

const routes = {
  test: include('', {
    self: 'welcome/test/login/:id',
    open: 'test/open/:id',
    welcome: 'test/welcome',
    detail: 'test/detail',
    question: 'test/question',
    validurl: 'test/not-valid-url',
    thankyou:"test/thankyou",
    timeover:"test/timeover",
    taboverlimit:"test/over-limit-tab-switching"
  }),
  admin: include('', {
    login: 'login',
    dashboard: include('dashboard', {
      user: include('user', {
        self: '',
        add: 'add',
        edit: 'edit/:id',
      }),
      candidates: 'candidate?',
      cadidateView:'candidate/:id',
      questionnaire: include('questionnaire', {
        self: '',
        add: 'add',
        edit: 'edit/:id',
      }),
      test: include('test', {
        self: '',
        add: 'add?',
        edit: 'edit/:id',
      }),
      invitation: 'invitation',
      profile: 'profile',
    }),
    preview: 'test/preview',
  }),
};

export default routes;
